import { useCallback, useEffect, useMemo, useState } from 'react';
import qs from 'qs';
import { useLocationState } from '../hooks';
import { context, StepsType } from '../model';
import { StartScreen } from '../start-screen';
import { SignUp } from '../sign-up';
import { Questionnaire } from '../questionnaire';
import s from './index.module.css';

export const Content = () => {
    const [email, setEmail] = useState('');

    const [{ query }, pushState] = useLocationState();
    const { step } = query;

    const nextStep = useCallback(
        (next: StepsType) =>
            pushState(qs.stringify({ ...query, step: next }, { addQueryPrefix: true })),
        [pushState]
    );

    const value = useMemo(
        () => ({
            email,
            setEmail,
            step: step as StepsType,
            nextStep
        }),
        [email, setEmail, step, nextStep]
    );

    useEffect(() => {
        if (!step || (step === 'signup' && !email)) nextStep('home');
    }, []);

    return (
        <context.Provider value={value}>
            {step === 'home' ? (
                <StartScreen />
            ) : (
                <div className={s.container}>
                    {step === 'signup' ? <SignUp /> : <Questionnaire />}
                </div>
            )}
        </context.Provider>
    );
};
